import Swiper from "swiper/dist/js/swiper.js";

export default {
    init() {
        // Accordion Section
        const accordions = document.getElementsByClassName('flex-accordion-section__accordion-container');
        if (accordions && accordions.length > 0) {
            for (let i = 0; i < accordions.length; i++) {
                const section = accordions[i];
                const toggle = section.querySelector('.flex-accordion-section__accordion-container__top__toggle');
                const body = section.querySelector('.flex-accordion-section__accordion-container__body');
                if (toggle) {
                    toggle.addEventListener('click', () => {
                        if (section.classList.contains('open')) {
                            section.classList.remove('open');
                            toggle.setAttribute('aria-expanded', false);
                            if (body) {
                                body.setAttribute('aria-hidden', true);
                            }
                        } else {
                            section.classList.add('open');
                            toggle.setAttribute('aria-expanded', true);
                            if (body) {
                                body.setAttribute('aria-hidden', false);
                            }
                        }
                    })
                }
            }
        }

        // Video Section
        const videoSections = document.querySelectorAll('.flex-video-section__video-container');

        if (videoSections && videoSections.length > 0) {
            for (let i = 0; i < videoSections.length; i++) {
                const section = videoSections[i];
                const overlay = section.querySelector('.flex-video-section__overlay');
                const playButton = section.querySelector('.flex-video-section__play-button');
                const caption = section.querySelector('.flex-video-section__caption');
                playButton.addEventListener('click', () => {
                    section.classList.add('play-video');
                    if (section.classList.contains('upload')) {
                        const video = section.querySelector('video');
                        video.play();
                        console.log('play upload video');
                    } else {
                        const iframe = section.querySelector('iframe');
                        iframe.setAttribute('src', '');
                        setTimeout(() => {
                            iframe.setAttribute('src', iframe.getAttribute('data-src'));
                        }, 100);
                    }
                });
            }
        }

        // Slider Section
        const sliderSections = document.querySelectorAll('.flex-slider-section');
        if (sliderSections && sliderSections.length > 0) {
            for (let i = 0; i < sliderSections.length; i++) {
                const section = sliderSections[i];
                const swiperContainer = section.querySelector('.swiper-container');
                const prev = section.querySelector('.swiper-button-prev');
                const next = section.querySelector('.swiper-button-next');
                const pagination = section.querySelector('.swiper-pagination');

                if (swiperContainer) {
                    const swiperSlides = swiperContainer.querySelectorAll('.swiper-slide');
                    const swiper = new Swiper(swiperContainer, {
                        slidesPerView: 1,
                        navigation: {
                            nextEl: next,
                            prevEl: prev
                        },
                        pagination: {
                            el: pagination,
                            type: "fraction",
                        },
                        on: {
                            init: () => {
                                const firstSlide = swiperSlides[0];
                                if (firstSlide) {
                                    if (firstSlide.classList.contains('light-card')) {
                                        swiperContainer.classList.add('light');
                                    } else {
                                        swiperContainer.classList.remove('light');
                                    }
                                }
                            },
                            slideChange: () => {
                                const activeSlide = swiperSlides[swiper.activeIndex];
                                if (activeSlide) {
                                    if (activeSlide.classList.contains('light-card')) {
                                        swiperContainer.classList.add('light');
                                    } else {
                                        swiperContainer.classList.remove('light');
                                    }
                                }
                            }
                        }
                    });
                }
            }
        }

        // Tab Section
        const tabSection = document.querySelectorAll('.flex-tab-section');
        if (tabSection && tabSection.length > 0) {
            for (let i = 0; i < tabSection.length; i++) {
                const section = tabSection[i];
                const tabs = section.querySelectorAll('.flex-tab-section__tabs__tab');
                if (tabs && tabs.length > 0) {
                    for (let n = 0; n < tabs.length; n++) {
                        const tab = tabs[n];
                        const button = tab.querySelector('button');
                        const otherTabs = section.querySelectorAll('.flex-tab-section__tabs__tab');

                        if (button) {
                            button.addEventListener('click', () => {
                                const contentID = button.getAttribute('aria-controls').split(' ')[0];
                                const content = section.querySelector('#' + contentID);
                                const responsiveContent = section.querySelector('#' + contentID + '-responsive');

                                if (!button.classList.contains('open')) {
                                    otherTabs.forEach((otherTab) => {
                                        if (otherTab !== tab) {
                                            otherTab.classList.remove('open');
                                            const otherButton = otherTab.querySelector('button');
                                            if (otherButton) {
                                                otherButton.setAttribute('aria-expanded', false);

                                                const otherContentID = otherButton.getAttribute('aria-controls').split(' ')[0];
                                                const otherContent = section.querySelector('#' + otherContentID);
                                                const otherResponsiveContent = section.querySelector('#' + otherContentID + '-responsive');

                                                if(otherContent) {
                                                    otherContent.setAttribute('aria-hidden', true);
                                                }
                                                if(otherResponsiveContent) {
                                                    otherResponsiveContent.setAttribute('aria-hidden', true);
                                                }
                                            }
                                        } else {
                                            tab.classList.add('open');
                                            button.setAttribute('aria-expanded', true);
                                            content.setAttribute('aria-hidden', false);
                                            responsiveContent.setAttribute('aria-hidden', false);
                                        }
                                    })
                                }

                                console.log('this is a test');
                            })
                        }
                    }
                }
            }
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
}